var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1742 9.64844C8.31924 9.64844 6 11.9677 6 14.8226V21.5186C6 24.3735 8.31924 26.6927 11.1742 26.6927H24.4231C24.9679 28.7898 26.8671 30.3451 29.1316 30.3451C31.816 30.3451 34.0014 28.1598 34.0014 25.4753C34.0014 23.2139 32.4461 21.3116 30.349 20.7668V14.8226C30.349 11.9677 28.0298 9.64844 25.1748 9.64844H11.1742ZM11.1742 10.8659H25.1748C27.3784 10.8659 29.1316 12.619 29.1316 14.8226V20.6055C26.4471 20.6055 24.2618 22.7908 24.2618 25.4753H11.1742C8.97058 25.4753 7.21745 23.7222 7.21745 21.5186V14.8226C7.21745 12.619 8.97058 10.8659 11.1742 10.8659ZM16.0622 14.8226V21.5855C16.0988 22.0056 16.6131 22.2886 16.9571 22.0695L22.4264 18.7215C22.7917 18.5054 22.7917 17.8327 22.4264 17.6197L16.9571 14.2717C16.5279 14.1073 16.0683 14.3021 16.0622 14.8226ZM17.2432 15.9061L20.932 18.1706L17.2432 20.435V15.9061ZM29.1316 21.5186C31.323 21.5186 33.0883 23.2839 33.0883 25.4753C33.0883 27.6667 31.323 29.432 29.1316 29.432C26.9401 29.432 25.1748 27.6667 25.1748 25.4753C25.1748 23.2839 26.9401 21.5186 29.1316 21.5186ZM29.1316 21.8229C28.7115 21.8229 28.3707 22.1638 28.3707 22.5838C28.3707 23.0039 28.7115 23.3448 29.1316 23.3448C29.5516 23.3448 29.8925 23.0039 29.8925 22.5838C29.8925 22.1638 29.5516 21.8229 29.1316 21.8229ZM29.1316 23.9535C28.7968 23.9535 28.5228 24.2274 28.5228 24.5622V28.5189C28.5228 28.8537 28.7968 29.1276 29.1316 29.1276C29.4664 29.1276 29.7403 28.8537 29.7403 28.5189V24.5622C29.7403 24.2274 29.4664 23.9535 29.1316 23.9535Z",
    fill: "#201F20",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircle);
export default __webpack_public_path__ + "static/media/PlayCircle.46fd3439ce77b23737a93d7525cf5f02.svg";
export { ForwardRef as ReactComponent };